import forms from './forms';
import message from '../common/message';
import { apiFetch } from '../common/utils';
import { t } from '../common/text';

export default ($, $wrapper, email, location) => {
    const $forms = $wrapper.find('.Forms.Identify');
    $forms.find('.Form').remove();

    $forms.html(
        forms({
            form: 'confirmLink'
        })
    );

    const $linkConfirm = $forms.find('.Form.ConfirmLink');
    const $identifyResendLink = $linkConfirm.find('a.ResendLink');

    $identifyResendLink.on('click', function () {
        message($, $wrapper, t('confirm.resending'), 'Warn');

        apiFetch({
            url: 'identify',
            body: {
                email: email,
                url: location
            }
        })
            .then((data) => {
                if (data.success) {
                    message($, $wrapper, t('confirm.resent'), 'Info');
                }
            })
            .catch((error) => {
                console.log(error);

                message($, $wrapper, t('common.server_error'), 'Error');
            });

        return false;
    });
};
